import React from 'react';
import {Button, message, Modal, Space, Upload} from 'antd';
import {useBoolean} from 'react-hanger';
import UseUser, {ExcelImportResponse} from '../../hooks/apis/useUser';
import usePost from '../../hooks/usePost';
import CommonApiErrorHandler from '../../utils/HttpInstance';

const {confirm} = Modal;

export default function ImportUserExcel(props: {refresh: () => any; isReviewer: boolean}) {
  const isUploading = useBoolean(false);
  const getUserTemplate = UseUser.getExcelTemplate();
  const upload = usePost<any, ExcelImportResponse>('user/importUser', {});
  function getExcelTemplate() {
    getUserTemplate
      .request()
      .then(res => {
        if (res.url) window.open(res.url, '_blank');
      })
      .catch(CommonApiErrorHandler);
  }

  function onSelectFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    formData.set('isReviewer', String(props.isReviewer));
    isUploading.setTrue();
    upload
      .request(formData, {
        onUploadProgress: () => console.log,
        timeout: 1000 * 60 * 60,
      })
      .then(res => {
        if (res.errorMessage) {
          confirm({
            title: res.errorMessage,
            content: res.errorExcelUrl && (
              <a href={res.errorExcelUrl} target={'_blank'}>
                下载错误标注 Excel
              </a>
            ),
          });
        } else {
          confirm({
            title: '导入完成',
            content: `新增 ${res.addCount} 条，跳过 ${res.passCount} 条`,
          });
        }
        isUploading.setFalse();
        props.refresh();
      })
      .catch(e => {
        isUploading.setFalse();
        message.error(e.message);
      });
    return false;
  }

  return (
    <Space>
      <a onClick={getExcelTemplate}>下载Excel 模板</a>
      <Upload accept={'application/xlsx'} beforeUpload={onSelectFile} showUploadList={false}>
        <Button loading={isUploading.value}>从 Excel 导入{props.isReviewer ? '评审员' : '学生'}</Button>
      </Upload>
    </Space>
  );
}
